import i18n from "i18next";
import {Trans as I18nTrans, initReactI18next, useTranslation} from "react-i18next";
import languageBundle from '@kirschbaum-development/laravel-translations-loader?namespace=translation!@kirschbaum-development/laravel-translations-loader';
import Cookies from 'js-cookie'
import {usePage} from "@inertiajs/inertia-react";

const preferedLanguage = Cookies.get('lang') ?? navigator.language ?? window.defaultLanguage ?? 'en';
const availableLanguages = window.availableLanguages ?? ['en'];
const language = availableLanguages.includes(preferedLanguage.slice(0,2)) ? preferedLanguage : availableLanguages[0];

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: languageBundle,
        lng: language,
        fallbackLng: 'en', // if you're using a language detector, do not define the lng option
        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescap
        },
        react: {
          bindI18n: 'loaded languageChanged',
          bindI18nStore: 'added',
          useSuspense: true,
        },
    });

export default i18n;

export function Trans(props) {
    const {t} = useTranslation();
    const { client } = usePage().props;

    if(props.getRaw === true) {
        if (i18n.exists(`${props.i18nKey}@${client.key}`)) {
            return <span dangerouslySetInnerHTML={{ __html: i18n.t(`${props.i18nKey}@${client.key}`) }}></span>
        }
        return <span dangerouslySetInnerHTML={{ __html: i18n.t(props.i18nKey) }}></span>
    }

    if (i18n.exists(`${props.i18nKey}@${client.key}`)) {
        const newProps = {
            ...props,
            i18nKey: `${props.i18nKey}@${client.key}`
        }
        return <I18nTrans {...newProps}/>;
    }

    return <I18nTrans {...props}/>;
}
